import React from 'react'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { B2CCard, DottedDivider } from '@masfront/common-b2c/src/modules/ui'

import {
  getProductNameForEnergyContract,
  getStateNameForEnergyContract,
} from '../helpers/EnergyContract.helpers'
import { EnergyContract } from '../model/energyContract.model'

import LineItem from '~/ui/components/LineItem/LineItem'
import { formatDate } from '~/utils'

const useStyles = makeStyles((theme) => {
  return {
    lineItem: {
      marginBottom: theme.spacing(2),
    },
  }
})

interface EnergyContractCardProps {
  energyContract: EnergyContract
}

const EnergyContractCard: React.FC<EnergyContractCardProps> = ({ energyContract }) => {
  const classes = useStyles()
  const noDataMessage = '-'

  return (
    <Box width="100%" gridColumn="1 / span 3" gridRow="auto / auto">
      <B2CCard title="Contrato de Energía" cardId={`energy-contract-${energyContract.id}`}>
        <Box display="flex">
          <Box mr={10}>
            <LineItem
              dataHook="energy-contract-product-type"
              className={classes.lineItem}
              primaryText="Producto"
              secondaryText={getProductNameForEnergyContract(energyContract) || noDataMessage}
            />
            <LineItem
              dataHook="energy-contract-state"
              className={classes.lineItem}
              primaryText="Estado"
              secondaryText={getStateNameForEnergyContract(energyContract) || noDataMessage}
            />
            <LineItem
              dataHook="energy-contract-supply-point-code"
              className={classes.lineItem}
              primaryText="CUPS"
              secondaryText={energyContract.supplyPointCode || noDataMessage}
            />
          </Box>
          <DottedDivider vertical />
          <Box ml={10}>
            <LineItem
              dataHook="energy-contract-create-date"
              className={classes.lineItem}
              primaryText="Fecha de contratación"
              secondaryText={formatDate(energyContract.createDate) || noDataMessage}
            />
            <LineItem
              dataHook="energy-contract-activation-date"
              className={classes.lineItem}
              primaryText="Fecha de activación"
              secondaryText={formatDate(energyContract.activationDate) || noDataMessage}
            />
          </Box>
        </Box>
      </B2CCard>
    </Box>
  )
}

export default EnergyContractCard
